import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import appontment_time from 'assets/branch/setting/APPOINTMENT_TIME.png'
import { TIME_APPOINTMENT } from '../form-branch'

const OpAppointmentTime = () => {
    const { t } = useTranslation()
    const optionAppointmentTime = [
        {
            name: t('BRANCH.INPUT.APPOINTMENT_TIME_BRANCH'), value: TIME_APPOINTMENT.CLINIC,
            component: <AppointmentTime showType='BRANCH' />,
        },
        {
            name: t('BRANCH.INPUT.APPOINTMENT_TIME_SCHEDULE'), value: TIME_APPOINTMENT.SCHEDULE,
            component: <AppointmentTime showType='SCHEDULE' />,
        }
    ]
    return (optionAppointmentTime)
}

export default OpAppointmentTime

interface AppointmentTimeProps {
    showType: 'BRANCH' | 'SCHEDULE'
}
const AppointmentTime = (props: AppointmentTimeProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom='16px'>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom='8px'>
                    {t('BRANCH.INPUT.APPOINTMENT_TIME')}
                </Typography>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'} >
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={appontment_time} alt="" />
                </Box>
            </Box>
            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.INPUT.APPOINTMENT_TIME_${showType}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.INPUT.SUB_APPOINTMENT_TIME_${showType}`)}
                </Typography>
            </Box>
        </Box>
    )
}